<mat-card>
  <mat-toolbar>{{title}}
    <span class="fill-remaining-space"></span>
    <!-- <button mat-icon-button matTooltip="Exportar la llista" aria-label="Exportar la llista" matTooltipClass="tooltip-style" (click)="exportar()" style="float: right">
      <mat-icon color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
    </button> -->
    <button mat-icon-button matTooltip="{{ 'facturesList.filtreToolTip' | translate }}" attr.aria-label="{{ 'facturesList.filtreToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-left:10px;margin-right: 0">
      <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <mcrit-gestio-factures-filtres
      *ngIf="showFilters"
      [validFilters]="facturesFilters"
      (changeFilter)="computeActiveFilters($event)"
      >
    </mcrit-gestio-factures-filtres>
    <!-- <div> (Atenció! Els filtres per estat de la factura són excloents. Format dates: YYYY-MM-DD)</div> -->
    <table style="padding-top:40px">
      <thead>
        <tr>
          <th style="width:40px">{{ 'facturesList.colNumero' | translate }}</th>
          <th>{{ 'facturesRebList.colActiva' | translate }}</th>
          <th (click)="cycleOrdering('projecte_codi')">{{ 'facturesList.colTreball' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['projecte_codi'] === 1 ?'keyboard_arrow_up' :(orderingParameters['projecte_codi'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th (click)="cycleOrdering('empresa')">{{ 'facturesList.colEmpresa' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['empresa'] === 1 ?'keyboard_arrow_up' :(orderingParameters['empresa'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:140px;text-align: right" (click)="cycleOrdering('data_factura')" *ngIf="!activeFilters.statePending">{{ 'facturesList.colDataFacturaHeader' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_factura'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_factura'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:210px;text-align: right" (click)="cycleOrdering('data_factura_prevista')" *ngIf="activeFilters.statePending">{{ 'facturesList.colDataPrevistaFactura' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_factura_prevista'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_factura_prevista'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:210px;text-align: right" (click)="cycleOrdering('data_cobrament_prevista')" *ngIf="activeFilters.stateWaiting">{{ 'facturesList.colDataPrevistaCobrament' | translate }}
              <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_cobrament_prevista'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_cobrament_prevista'] === 2 ?'keyboard_arrow_down' : '')
              )}}
              </mat-icon>
          </th>
          <th style="width:140px;text-align: right" (click)="cycleOrdering('data_cobrament')" *ngIf="activeFilters.stateCharged">{{ 'facturesList.colDataCobramentHeader' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_cobrament'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_cobrament'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:100px;text-align: right" (click)="cycleOrdering('facturacio_prevista_eur')">{{ 'facturesList.colEur' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['facturacio_prevista_eur'] === 1 ?'keyboard_arrow_up' :(orderingParameters['facturacio_prevista_eur'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:100px;text-align: right" (click)="cycleOrdering('facturacio_prevista_loc')">{{ 'facturesList.colLocal' | translate }}
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['facturacio_prevista_loc'] === 1 ?'keyboard_arrow_up' :(orderingParameters['facturacio_prevista_loc'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:60px;text-align: right" (click)="cycleOrdering('facturacio_prevista_percent')">{{ 'facturesList.colPercent' | translate }}
            <mat-icon style="vertical-align: middle;text-align: right">
              {{(
                 orderingParameters['facturacio_prevista_percent'] === 1 ?'keyboard_arrow_up' :(orderingParameters['facturacio_prevista_percent'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="elementList">
          <tr *ngFor="let finvoice of elementList.rows; let j = index" (click)="this.goProject(finvoice.projecte_codi)"  style="cursor:pointer">
            <td>
              {{finvoice.numero_factura}}
            </td>
            <td *ngIf="finvoice.activa">
              <mat-icon>check_box</mat-icon>
            </td>
            <td *ngIf="!finvoice.activa">
              <mat-icon>check_box_outline_blank</mat-icon>
            </td>
            <td>
              <span *ngIf="finvoice.ambit_proposta=='Europa'" style='color:#0000FF'>{{finvoice.clau}}</span>
              <span *ngIf="finvoice.ambit_proposta=='Internacional'" style='color:#008800'>{{finvoice.clau}}</span>
              <span *ngIf="finvoice.ambit_proposta=='Espanya'" style='color:#800000'>{{finvoice.clau}}</span>
              <span *ngIf="finvoice.ambit_proposta=='Catalunya'" style='color:rgb(100,100,100)'>{{finvoice.clau}}</span>
            </td>
            <td *ngIf="!activeFilters.empresa" style="text-align: left">
              {{finvoice.empresa}}
            </td>
            <td *ngIf="!activeFilters.statePending" style="text-align: right">
              {{finvoice.data_factura | date}}
            </td>
            <td *ngIf="activeFilters.statePending" style="text-align: right">
              {{finvoice.data_factura_prevista | date}}
            </td>
            <td *ngIf="activeFilters.stateWaiting" style="text-align: right">
              {{finvoice.data_cobrament_prevista | date}}
            </td>
            <td *ngIf="activeFilters.stateCharged" style="text-align: right">
              {{finvoice.data_cobrament | date}}
            </td>
            <td style="text-align: right">
              {{finvoice.facturacio_prevista_eur  | number:'1.0-2' }}
            </td>
            <td style="text-align: right">
              {{finvoice.facturacio_prevista_loc  | number:'1.0-2' }}
            </td>
            <td style="text-align: right">
              {{finvoice.facturacio_prevista_percent | number }}
            </td>
          </tr>
        </tbody>
    </table>
  </mat-card-content>
  <mcrit-gestio-invoices-resume
    [dades]="resumeData">
  </mcrit-gestio-invoices-resume>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{ 'facturesList.liniesPag' | translate }}: {{listService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="elementList">
      {{ 'facturesList.resumRegistres' | translate:{ first: firstRegisterShown, last: lastRegisterShown, total: elementList.registers } }}
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>
<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>
